export const API_URL = "https://qwtoolsapi.azurewebsites.net/"; // PROD
//export const API_URL = "https://localhost:7213/"; // Local

export const CLIENT_VERSION = "Version 1.0.3 2026-10-20"; //Denna måste stämma överens med klientversionen i servern (Constants.ClientVersion)!!
